import { render, staticRenderFns } from "./SsoAuthorize.vue?vue&type=template&id=f97b9020&scoped=true"
import script from "./SsoAuthorize.vue?vue&type=script&lang=js"
export * from "./SsoAuthorize.vue?vue&type=script&lang=js"
import style0 from "./SsoAuthorize.vue?vue&type=style&index=0&id=f97b9020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b9020",
  null
  
)

export default component.exports